import React from "react";
import { AccountRolePresence } from "@common/types/domains/accounting/account";
import { AccountingReportFilters } from "../types";

export const AccountRolePresenceFilterLabel: React.FC<{
    filters: AccountingReportFilters;
}> = ({ filters }) => (
    <>
        {filters.accountRolePresence === AccountRolePresence.HAS_ROLE
            ? "Has role"
            : "No role"}
    </>
);
